import { jsx as _jsx } from "react/jsx-runtime";
import { ArrowContainer } from './styles';
const HdArrow = ({ dir }) => {
    return (_jsx(ArrowContainer, { className: "hd-arrow", "$dir": dir, children: _jsx("svg", { width: "8.73", height: "16", viewBox: "0 0 12 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: { transform: `scale(${dir === 'left' ? -1 : 1})` }, children: _jsx("path", { d: "M1 1L10.8182 11L1 21", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }) }) }));
};
export default HdArrow;
